import {doc} from './docs.js';
doc(
    "loadBang",
    {
    },
    "Sends bang on load",
    undefined,
    {
        tags: "Bang"
    });

export const loadBang = (object) => {
    object.needsLoad = true; 
    return () => {
        return ['bang'];
    };
};

doc(
    "startBang",
    {
    },
    "Sends bang on start",
    undefined,
    {
        tags: "Bang"
    });

export const startBang = (object) => {
    object.needsStart = true; 
    return () => {
        return ['bang'];
    };
};

